/* 7 O'CLOCK – Warenkorb-Drawer V1 (13.10.2026, Alina)
   Ergänzt den bestehenden Liquify-Warenkorb (snippets/mini_cart.liquid bleibt unverändert):
   - Upsell „Passt perfekt dazu“: Produkte aus custom.upsell_produkte der Artikel im Warenkorb
     (Endpunkt /products/<handle>?view=oc-upsell), sonst Shopify-Empfehlungen. Ein Tipp legt das Produkt in den Warenkorb.
   - Benefits-Zeile unter dem Kasse-Button (Texte: window.ocCartCfg.benefits aus snippets/gtm-head.liquid)
   - Artikelanzahl im Kopf, „Zwischensumme“ + „inkl. MwSt.“, Versandkosten als „5,99 €“
   - Höhe des fixen Footers → Abstand im Scrollbereich (nichts wird verdeckt)
   Styles: assets/7oc-cart.css */
(function () {
  'use strict';
  if (window.__ocCart) return;
  window.__ocCart = true;

  var CFG = window.ocCartCfg || {};
  var FILES = '//7oclock.de/cdn/shop/files/';
  var BENEFITS = (CFG.benefits && CFG.benefits.length) ? CFG.benefits : [
    { img: FILES + 'Icons_kostenloser-Versand_e698c8f8-4c8b-421a-8efc-6620d748943a.png?width=52', text: 'Kostenloser Versand', sub: 'ab 69 € (DE)' },
    { img: FILES + 'icon-schnelle-lieferung-01_schnelle-Lieferung.png?width=52', text: 'Schnelle Lieferung', sub: '1–3 Tage mit [DHL] DHL Premium' },
    { img: FILES + 'Icons_warenkorb-14-tage-geld-zurueck.png?width=52', text: 'Geld-zurück-Garantie', sub: '14 Tage Rückgabe' },
    { img: FILES + 'ab0abf970fb06f6458e420cd479961e6d9d95efe.png?width=52', text: 'Versandschutz', sub: 'Ersatz bei Bruch & Verlust' }
  ];
  var UPSELL_TITLE = CFG.upsellTitle || 'Passt <em>perfekt dazu</em>';
  var MAX_UPSELLS = CFG.maxUpsells || 6;

  var ICONS = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17" r="1.7"/><circle cx="17" cy="17" r="1.7"/></svg>',
    return: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h11a5 5 0 0 1 0 10H8"/><path d="M8 5L4 9l4 4"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="10.5" width="14" height="9.5" rx="2"/><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8.5" width="17" height="4"/><path d="M5 12.5v8h14v-8M12 8.5v12M12 8.5c-1.5-3.5-5.5-4-5.5-1.5 0 1.5 3 1.5 5.5 1.5zm0 0c1.5-3.5 5.5-4 5.5-1.5 0 1.5-3 1.5-5.5 1.5z"/></svg>',
    heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true"><path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.4a4.3 4.3 0 0 1 7.5 2.4C19.5 15.4 12 20 12 20z"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7.5 3v5.5c0 4.5-3.2 8-7.5 9.5-4.3-1.5-7.5-5-7.5-9.5V6z"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 12.6V4.5a1 1 0 0 1 1-1h8.1l7.9 7.9a1 1 0 0 1 0 1.4l-7.4 7.4a1 1 0 0 1-1.4 0z"/><circle cx="8.3" cy="8.3" r="1.5"/></svg>',
    arrowL: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    arrowR: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>',
    checkCircle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12.4l2.7 2.7L16.2 9.5"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };

  function money(c) {
    var s = (Math.round(c) / 100).toFixed(2).split('.');
    return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1] + ' €';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmtTitle(t) {
    t = String(t || '');
    var i = t.lastIndexOf(',');
    return (i > 0 && i < t.length - 1) ? t.slice(0, i).trim() + ' | ' + t.slice(i + 1).trim() : t;
  }
  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }
  /* „24-teiliges Geschirrset Cremeweiß glänzend, Nia“ bzw. „… | Nia“ → { name: 'Nia', desc: '24-teiliges Geschirrset …' } */
  function splitTitle(t) {
    t = String(t || '').trim();
    var i = t.lastIndexOf(' | '), n = 3;
    if (i < 0) { i = t.lastIndexOf(','); n = 1; }
    if (i > 0 && i < t.length - n) return { name: t.slice(i + n).trim(), desc: t.slice(0, i).trim() };
    return { name: t, desc: '' };
  }
  function cents(txt) {
    var m = String(txt || '').replace(/\s/g, '').match(/(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/);
    return m ? parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10) : 0;
  }
  function mk(tag, cls, parent, before) {
    var el = document.createElement(tag); el.className = cls;
    if (parent) parent.insertBefore(el, before || null);
    return el;
  }

  /* ---------- Warenkorb-Daten ---------- */
  var cart = null, cartReq = null;
  function loadCart() {
    if (cartReq) return cartReq;
    cartReq = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; cartReq = null; return c; })
      .catch(function () { cartReq = null; return cart; });
    return cartReq;
  }

  /* ---------- Upsell-Quellen ---------- */
  var upCache = {};
  try { upCache = JSON.parse(sessionStorage.getItem('oc-cart-upsells') || '{}') || {}; } catch (e) {}
  function saveCache() { try { sessionStorage.setItem('oc-cart-upsells', JSON.stringify(upCache)); } catch (e) {} }

  function upsellsFor(handle) {
    if (upCache[handle]) return Promise.resolve(upCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '?view=oc-upsell', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : '[]'; })
      .then(function (t) { var l; try { l = JSON.parse(t.trim()); } catch (e) { l = []; } upCache[handle] = Array.isArray(l) ? l : []; saveCache(); return upCache[handle]; })
      .catch(function () { return []; });
  }
  /* Einzelblumen (31.10.2026, Alina): lose Bloom-Stiele (Produkttyp „Kunstblume“, Tag „TT-Ausschluss“ bzw. ohne
     „Bouquet“/„Strauß“/„Set“ im Titel) sind Bestandteile der Sträuße und dürfen NIE als Upsell erscheinen.
     Gilt für Shopify-Empfehlungen und Bestseller; das Metafeld-Endpunkt (oc-upsell) filtert zusätzlich in Liquid. */
  function isStem(p) {
    if (!p) return false;
    var type = String(p.type || p.product_type || '');
    var tags = p.tags || [];
    if (typeof tags === 'string') tags = tags.split(/,\s*/);
    if (!/kunstblume/i.test(type)) return false;
    return tags.indexOf('TT-Ausschluss') > -1 || !/bouquet|strau|\bset\b/i.test(String(p.title || ''));
  }
  function recsFor(productId, intent) {
    var key = 'rec2:' + productId + ':' + intent; /* rec2: Cache ohne Einzelblumen (31.10.2026) */
    if (upCache[key]) return Promise.resolve(upCache[key]);
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=' + intent, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var l = (d.products || []).filter(function (p) { return p.available && !isStem(p); }).map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
          var multi = !(p.variants && p.variants.length === 1 && v.title === 'Default Title');
          return {
            id: p.id, handle: p.handle, url: p.url, title: p.title, subline: '',
            image: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '',
            variant: v.id, variant_title: multi ? v.title : '', multi: multi, price: v.price, compare: v.compare_at_price || 0
          };
        });
        upCache[key] = l; saveCache(); return l;
      })
      .catch(function () { return []; });
  }

  function collectUpsells(c) {
    var items = (c && c.items) || [];
    if (!items.length) return Promise.resolve([]);
    var inCart = {}, handles = [];
    items.forEach(function (it) { inCart[it.product_id] = true; if (handles.indexOf(it.handle) < 0) handles.push(it.handle); });
    return Promise.all(handles.map(upsellsFor)).then(function (lists) {
      var out = [], seen = {};
      lists.forEach(function (l) {
        l.forEach(function (p) {
          if (!p || inCart[p.id] || seen[p.id] || !p.variant) return;
          seen[p.id] = true; out.push(p);
        });
      });
      if (out.length) return out.slice(0, MAX_UPSELLS);
      return recsFor(items[0].product_id, 'complementary').then(function (l) {
        return l.length ? l : recsFor(items[0].product_id, 'related');
      }).then(function (l) {
        return l.filter(function (p) { return !inCart[p.id]; }).slice(0, MAX_UPSELLS);
      });
    });
  }

  /* Restbetrag bis zum kostenlosen Versand (Schwelle aus den Einstellungen, Standard 69 €) */
  function remaining() {
    var from = Math.round((CFG.freeFrom || 69) * 100);
    return cart ? Math.max(0, from - (cart.total_price || 0)) : 0;
  }

  /* ---------- Upsell-Darstellung ---------- */
  var lastUpKey = '';
  function cardHtml(p) {
    var sale = p.compare && p.compare > p.price;
    var tt = splitTitle(p.title);
    return '<div class="oc-cu_card" data-variant="' + esc(p.variant) + '">' +
      '<a class="oc-cu_img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="56" height="68">' : '') + '</a>' +
      '<div class="oc-cu_info"><a class="oc-cu_name" href="' + esc(p.url) + '">' + esc(tt.name) + '</a>' +
      (tt.desc ? '<span class="oc-cu_meta">' + esc(tt.desc) + '</span>' : '') +
      '<span class="oc-cu_price' + (sale ? ' is-sale' : '') + '">' + (sale ? '<s>' + money(p.compare) + '</s>' : '') + '<b>' + money(p.price) + '</b></span></div>' +
      '<button type="button" class="oc-cu_add" aria-label="' + esc(tt.name + ' ' + tt.desc) + ' in den Warenkorb legen">' + ICONS.plus + '</button>' +
      '</div>';
  }
  function renderUpsells(list) {
    var wrap = document.querySelector('.mini-cart_modal .mini-cart_item-list-wrapper');
    if (!wrap) return;
    var box = wrap.querySelector('.oc-cu');
    if (!box) {
      box = document.createElement('div');
      box.className = 'oc-cu';
      box.hidden = true;
      box.innerHTML = '<div class="oc-cu_head"><h3 class="oc-cu_title-h">' + UPSELL_TITLE + '</h3>' +
        '<div class="oc-cu_nav"><button type="button" class="oc-cu_arrow" data-dir="-1" aria-label="Zurück">' + ICONS.arrowL + '</button>' +
        '<button type="button" class="oc-cu_arrow" data-dir="1" aria-label="Weiter">' + ICONS.arrowR + '</button></div></div><div class="oc-cu_row" role="list"></div>';
      wrap.appendChild(box);
      box.addEventListener('click', onAdd);
      box.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('.oc-cu_arrow');
        if (!a) return;
        var row = box.querySelector('.oc-cu_row'), card = row.querySelector('.oc-cu_card');
        row.scrollBy({ left: (card ? card.getBoundingClientRect().width + 8 : 240) * Number(a.getAttribute('data-dir')), behavior: 'smooth' });
      });
      box.querySelector('.oc-cu_row').addEventListener('scroll', function () { navState(box); }, { passive: true });
    }
    var key = list.map(function (p) { return p.variant; }).join(',') + '|' + remaining();
    if (key === lastUpKey && box.querySelector('.oc-cu_card')) { box.hidden = !list.length; navState(box); return; }
    lastUpKey = key;
    box.querySelector('.oc-cu_row').innerHTML = list.map(cardHtml).join('');
    box.hidden = !list.length;
    requestAnimationFrame(function () { navState(box); });
  }
  function navState(box) {
    var row = box.querySelector('.oc-cu_row'); if (!row) return;
    var arrows = box.querySelectorAll('.oc-cu_arrow');
    var max = row.scrollWidth - row.clientWidth;
    if (row.clientWidth > 0) box.querySelector('.oc-cu_nav').hidden = max < 4;
    if (arrows[0]) arrows[0].disabled = row.scrollLeft < 4;
    if (arrows[1]) arrows[1].disabled = row.scrollLeft > max - 4;
  }
  function onAdd(e) {
    var btn = e.target.closest && e.target.closest('.oc-cu_add');
    if (!btn || btn.disabled) return;
    var card = btn.closest('.oc-cu_card');
    var id = card && card.getAttribute('data-variant');
    if (!id) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: { _source: 'Warenkorb-Upsell' } }] })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      btn.classList.add('is-done'); btn.innerHTML = ICONS.check;
      window.dispatchEvent(new CustomEvent('cartupdated'));
      setTimeout(refresh, 900);
    }).catch(function () {
      btn.disabled = false;
      btn.setAttribute('aria-label', 'Leider nicht verfügbar – bitte erneut versuchen');
    });
  }

  /* ---------- Benefits, Kopf, Summen ---------- */
  /* Benefits als Raster unter der Übersicht (scrollt mit) */
  function ensureBenefits() {
    var full = document.querySelector('.mini-cart_modal .mini-cart_full');
    var foot = full && full.querySelector('.mini-cart_footer');
    if (!foot) return;
    var ul = full.querySelector('.oc-cb');
    if (!ul) {
      ul = document.createElement('ul');
      ul.className = 'oc-cb';
      var dhl = CFG.dhlLogo ? '<img class="oc-cb_logo" src="' + esc(CFG.dhlLogo) + '" alt="DHL" width="28" height="14">' : '';
      ul.innerHTML = BENEFITS.map(function (b) {
        var icon = b.img ? '<img class="oc-cb_icon" src="' + esc(b.img) + '" alt="" width="20" height="20" loading="lazy">' : (ICONS[b.icon] || '');
        var sub = esc(b.sub || '').replace('[DHL]', dhl);
        return '<li>' + icon + '<strong>' + esc(b.text) + '</strong>' + (sub ? ' <span>' + sub + '</span>' : '') + '</li>';
      }).join('');
    }
    if (foot.nextElementSibling !== ul) full.insertBefore(ul, foot.nextSibling);
  }

  /* Fixe Kassen-Leiste, sobald der Kasse-Button aus dem Bild scrollt */
  function ensureSticky() {
    var side = document.querySelector('.mini-cart_modal .mini-cart_sidebar');
    var full = side && side.querySelector('.mini-cart_full');
    var btn = full && full.querySelector('.mini-cart_payment > a.button');
    if (!btn) return;
    var bar = side.querySelector('.oc-sticky');
    if (!bar) {
      bar = mk('div', 'oc-sticky', side);
      bar.innerHTML = '<div class="oc-sticky_sum"><span>Zwischensumme</span><b></b></div><a class="oc-sticky_btn" href="' + esc(btn.getAttribute('href') || '/checkout') + '">' + ICONS.lock + '<span>Zur Kasse</span></a>';
    }
    var amt = full.querySelector('.mini-cart_footer-details .text-block-2');
    setText(bar.querySelector('b'), amt ? amt.textContent.trim() : '');
    stickyCheck();
    if (!full.__ocSticky) {
      full.__ocSticky = true;
      full.addEventListener('scroll', stickyCheck, { passive: true });
      window.addEventListener('resize', stickyCheck);
    }
  }
  function stickyCheck() {
    var side = document.querySelector('.mini-cart_modal .mini-cart_sidebar');
    var full = side && side.querySelector('.mini-cart_full');
    var bar = side && side.querySelector('.oc-sticky');
    var btn = full && full.querySelector('.mini-cart_payment > a.button');
    if (!bar || !btn) return;
    var fr = full.getBoundingClientRect(), br = btn.getBoundingClientRect();
    var visible = fr.height > 0 && br.top < fr.bottom - 10 && br.bottom > fr.top + 52;
    bar.classList.toggle('is-on', fr.height > 0 && !visible && !!(cart && cart.item_count));
  }
  /* Artikel: Name / Beschreibung / Setgröße wie auf den Produktkarten, Ersparnis pro Artikel */
  var totalSave = 0;
  function items() {
    totalSave = 0;
    document.querySelectorAll('.mini-cart_modal .mini-cart_item').forEach(function (li) {
      var head = li.querySelector('.mini-cart_item-heading'), title = li.querySelector('.mini-cart_item-title');
      if (head && title) {
        var tt = splitTitle(title.textContent);
        var nm = head.querySelector('.oc-it-name') || mk('div', 'oc-it-name', head, title);
        var ds = head.querySelector('.oc-it-desc') || mk('div', 'oc-it-desc', head, title.nextSibling);
        setText(nm, tt.name); setText(ds, tt.desc); ds.hidden = !tt.desc;
        li.classList.add('oc-it');
      }
      var box = li.querySelector('.mini-cart_price');
      var save = 0;
      if (box) {
        var cmpEl = box.querySelector('.oc-cmp') || box.querySelector('.mini-cart_compare-at-price');
        var cur = box.lastElementChild;
        if (cmpEl && cmpEl.offsetParent !== null && cur && cur !== cmpEl) save = cents(cmpEl.textContent) - cents(cur.textContent);
      }
      if (save < 0) save = 0;
      totalSave += save;
      if (head) {
        var sv = head.querySelector('.oc-it-save');
        if (save > 0) { if (!sv) sv = mk('div', 'oc-it-save', head); setText(sv, 'Du sparst ' + money(save)); }
        else if (sv) sv.remove();
      }
    });
  }

  /* Lieferzeit DE: DHL 1–3 Werktage. Bestellung bis 12 Uhr → Versand heute, danach am nächsten Werktag.
     Werktage = Mo–Fr ohne bundesweite Feiertage. Zeitzone Europe/Berlin. */
  function berlinNow() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return { d: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), h: +p.hour % 24 };
    } catch (e) { var n = new Date(); return { d: new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())), h: n.getHours() }; }
  }
  var holCache = {};
  function holidays(y) {
    if (holCache[y]) return holCache[y];
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
      h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      mon = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    var easter = Date.UTC(y, mon - 1, day), D = 864e5, set = {};
    [easter - 2 * D, easter + D, easter + 39 * D, easter + 50 * D, Date.UTC(y, 0, 1), Date.UTC(y, 4, 1), Date.UTC(y, 9, 3), Date.UTC(y, 11, 25), Date.UTC(y, 11, 26)]
      .forEach(function (t) { set[new Date(t).toISOString().slice(0, 10)] = true; });
    return (holCache[y] = set);
  }
  function isWorkday(dt) { var w = dt.getUTCDay(); return w > 0 && w < 6 && !holidays(dt.getUTCFullYear())[dt.toISOString().slice(0, 10)]; }
  function addWorkdays(dt, n) { var x = new Date(dt.getTime()); while (n > 0) { x = new Date(x.getTime() + 864e5); if (isWorkday(x)) n--; } return x; }
  function fmtDay(dt) {
    var wd = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'][dt.getUTCDay()];
    return wd + ' ' + ('0' + dt.getUTCDate()).slice(-2) + '.' + ('0' + (dt.getUTCMonth() + 1)).slice(-2) + '.';
  }
  function deliveryText() {
    var now = berlinNow(), cutoff = CFG.cutoffHour == null ? 12 : CFG.cutoffHour;
    var ship = (isWorkday(now.d) && now.h < cutoff) ? now.d : addWorkdays(now.d, 1);
    return 'Lieferung ca. ' + fmtDay(addWorkdays(ship, CFG.minDays || 1)) + ' – ' + fmtDay(addWorkdays(ship, CFG.maxDays || 3));
  }

  function payments() {
    var list = document.querySelector('.mini-cart_modal .mini-cart_payment-list');
    if (!list || list.previousElementSibling && list.previousElementSibling.classList.contains('oc-pay-h')) return;
    var h = document.createElement('div'); h.className = 'oc-pay-h'; h.textContent = CFG.payTitle || 'Wir akzeptieren';
    list.parentNode.insertBefore(h, list);
  }
  function discountField() {
    var i = document.querySelector('.mini-cart_modal .mini-cart_discount-input');
    if (i && i.getAttribute('placeholder') !== 'Rabattcode eingeben') i.setAttribute('placeholder', 'Rabattcode eingeben');
    var b = document.querySelector('.mini-cart_modal .mini-cart_discount-button > div');
    if (b && b.textContent.trim() !== 'Einlösen') b.textContent = 'Einlösen';
  }
  function removeLabels() {
    document.querySelectorAll('.mini-cart_modal .mini-cart_item-remove').forEach(function (b) {
      if (!b.querySelector('.oc-rm')) { var sp = document.createElement('span'); sp.className = 'oc-rm'; sp.textContent = 'Entfernen'; b.appendChild(sp); }
    });
  }

  function footerExtras() {
    var main = document.querySelector('.mini-cart_modal .mini-cart_footer-main');
    var det = main && main.querySelector('.mini-cart_footer-details');
    if (!det) return;
    /* Ersparnis gesamt */
    var sv = main.querySelector('.oc-save');
    if (!sv) { sv = mk('div', 'oc-save', main, main.firstChild); sv.innerHTML = ICONS.checkCircle + '<span></span>'; }
    setText(sv.querySelector('span'), totalSave > 0 ? 'Du sparst insgesamt ' + money(totalSave) : '');
    sv.hidden = !(totalSave > 0);
    /* Lieferzeit unter der Versandzeile */
    var shipRow = det.querySelector('.mini-cart_footer-total');
    if (shipRow) {
      var dl = det.querySelector('.oc-delivery');
      if (!dl) {
        dl = mk('div', 'oc-delivery', det, shipRow.nextSibling);
        dl.innerHTML = (CFG.dhlLogo ? '<img class="oc-dhl" src="' + esc(CFG.dhlLogo) + '" alt="DHL" width="34" height="17">' : ICONS.truck) + '<span></span>';
      }
      setText(dl.querySelector('span'), deliveryText());
      var lbl = shipRow.querySelector('.mini-cart_shipping-text');
      if (lbl && /versandkosten|versand \(de\)/i.test(lbl.textContent)) setText(lbl, 'Versand Deutschland');
    }
    /* Rabattcode: Icon in Grün */
    var tg = document.querySelector('.mini-cart_modal .mini-cart_discount-toggle');
    if (tg && !tg.querySelector('.oc-tag')) { var ic = document.createElement('span'); ic.className = 'oc-tag'; ic.innerHTML = ICONS.tag; tg.insertBefore(ic, tg.firstChild); }
  }

  function headerCount() {
    var h = document.querySelector('.mini-cart_modal .mini-cart_full > .mini-cart_heading .modal_heading');
    if (!h || !cart) return;
    var n = cart.item_count || 0;
    var tn = h.firstChild;
    if (tn && tn.nodeType === 3 && tn.nodeValue.trim() !== (CFG.cartTitle || 'Warenkorb')) tn.nodeValue = CFG.cartTitle || 'Warenkorb';
    var span = h.querySelector('.oc-cart-count');
    if (!span) { span = document.createElement('span'); span.className = 'oc-cart-count'; h.appendChild(span); }
    setText(span, n ? String(n) : '');
    span.hidden = !n;
  }
  function totals() {
    var m = document.querySelector('.mini-cart_modal .mini-cart_footer-details');
    if (!m) return;
    var lbl = m.querySelector('.mini-cart_total');
    setText(lbl, 'Zwischensumme');
    if (lbl && !m.querySelector('.oc-tax')) { var t = document.createElement('span'); t.className = 'oc-tax'; lbl.parentNode.insertBefore(t, lbl.nextSibling); }
    var paidShip = false;
    m.querySelectorAll('.mini-cart_footer-price .mini-cart_text').forEach(function (el) {
      var raw = el.textContent.replace(/\s+/g, ' ').trim();
      var mm = raw.match(/^([\d.,]+)\s*(€)?\s*\(DE\)$/);
      if (mm) setText(el, mm[1] + ' €');
      if (/^kostenlos\s*\(de\)$/i.test(raw)) setText(el, 'Kostenlos');
      if (el.offsetParent !== null && /\d/.test(el.textContent) && !el.classList.contains('text-color-red') && !el.closest('.oc-hidden-save')) paidShip = true;
    });
    setText(m.querySelector('.oc-tax'), 'inkl. MwSt.');
    /* Theme-Zeile „Du sparst“ ausblenden – die Ersparnis steht jetzt oben im Footer */
    m.querySelectorAll('.mini-cart_footer-total').forEach(function (r) { if (r.querySelector('.text-color-red')) r.classList.add('oc-hidden-save'); });
  }
  function footerSpace() {
    var f = document.querySelector('.mini-cart_modal .mini-cart_footer');
    var full = document.querySelector('.mini-cart_modal .mini-cart_full');
    if (!f || !full) return;
    var h = Math.ceil(f.getBoundingClientRect().height);
    if (h > 40 && full.style.getPropertyValue('--oc-foot-h') !== h + 'px') full.style.setProperty('--oc-foot-h', h + 'px');
  }

  /* ---------- Ablauf ---------- */
  var busy = false, queued = false;
  function progressText() {
    document.querySelectorAll('.mini-cart_modal .mini-cart_progress-success:not(.mini-cart_progress-digital) > div:not([class])').forEach(function (el) {
      if (/kostenlos/i.test(el.textContent)) setText(el, CFG.freeShippingText || 'Dein Versand ist kostenlos.');
    });
  }
  function decorate() { ensureBenefits(); headerCount(); items(); removeLabels(); discountField(); totals(); footerExtras(); payments(); progressText(); ensureSticky(); var cu = document.querySelector('.oc-cu'); if (cu && !cu.hidden) navState(cu); }
  function refresh() {
    if (busy) { queued = true; return; }
    busy = true;
    loadCart().then(function (c) {
      decorate();
      return collectUpsells(c).then(renderUpsells);
    }).catch(function () {}).then(function () {
      busy = false;
      if (queued) { queued = false; setTimeout(refresh, 50); }
    });
  }
  var t = null;
  function schedule(delay) { clearTimeout(t); t = setTimeout(refresh, delay || 150); }

  function init() {
    var modal = document.querySelector('.mini-cart_modal');
    if (!modal) return setTimeout(init, 500);
    /* Ladezeit 30.10.2026: Der erste Aufbau (Warenkorb laden, Upsells holen, Drawer dekorieren) lief bisher sofort beim Seitenstart bei geschlossenem Warenkorb.
       Jetzt erst nach „load“ im Leerlauf – oder sofort, wenn der Warenkorb offen ist / geöffnet wird / sich ändert (die Listener unten lösen refresh aus). */
    if (getComputedStyle(modal).display !== 'none') refresh();
    else {
      var idleRefresh = function () { if (window.requestIdleCallback) requestIdleCallback(function () { refresh(); }, { timeout: 3000 }); else setTimeout(refresh, 1500); };
      if (document.readyState === 'complete') idleRefresh(); else window.addEventListener('load', idleRefresh);
    }
    window.addEventListener('cartupdated', function () { schedule(700); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[fs-modal-element="open-1111"]')) schedule(300); });
    if (typeof MutationObserver !== 'undefined') {
      var raf = null;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var n = muts[i].target; var el = n.nodeType === 1 ? n : n.parentElement;
          if (muts[i].type === 'attributes' && n.nodeType === 1 && muts[i].oldValue === n.getAttribute(muts[i].attributeName)) continue; /* gleicher Wert = keine Änderung (22.10.2026, Endlosschleife) */
          if (el && el.closest && el.closest('.oc-cu, .oc-cb, .oc-tax, .oc-cart-count, .oc-it-name, .oc-it-desc, .oc-it-save, .oc-save, .oc-delivery, .oc-tag, .oc-sticky, .oc-pay-h, .oc-rm')) continue;
          if (muts[i].type === 'attributes' && el && el.classList && el.classList.contains('mini-cart_full')) continue;
          if (!raf) raf = requestAnimationFrame(function () { raf = null; decorate(); });
          return;
        }
      }).observe(modal, { childList: true, subtree: true, characterData: true, attributes: true, attributeOldValue: true, attributeFilter: ['style', 'class'] });
    }

    setInterval(function () { if (document.querySelector('.oc-delivery')) footerExtras(); }, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
